// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__ZVk6","pages":"Pagination_pages_cTpM1","active":"Pagination_active_j2xiV"};